/* Bonzentrale Rollenfinder — technische Suche.

   Zwei Einstiege, EIN Matcher:
     Groessenmodus  — der Nutzer waehlt Stufe fuer Stufe (Breite, Durchmesser, …).
     Geraetemodus   — eine Geraete-Spezifikation filtert vor, danach laeuft
                      dieselbe Stufenlogik auf der reduzierten Menge.

   Sackgassenfreiheit: jede Stufe zeigt nur Werte, die bei der aktuellen Auswahl
   noch mindestens einen Treffer liefern. Optionen mit 0 Treffern erscheinen nicht.

   Unbekannte Angaben in einer Geraete-Spezifikation sind IMMER "keine
   Einschraenkung" und werden nie als 0 gelesen — ein fehlender Wert darf kein
   Produkt ausschliessen.

   Die Datei laeuft im Browser und ist zugleich aus Node heraus ladbar, damit
   der Matcher ohne DOM getestet werden kann (tools/test_rollenfinder_core.cjs).
*/
(function (global, factory) {
  'use strict';
  var BZ = factory();
  if (typeof module !== 'undefined' && module.exports) { module.exports = BZ; }
  if (global) { global.BZRollenfinder = BZ; BZ.autoInit(); }
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';

  var MAX_TREFFER = 24;
  var STUFEN = [
    { key: 'breite',      label: 'Breite',      einheit: ' mm' },
    { key: 'durchmesser', label: 'Durchmesser', einheit: ' mm', prefix: 'Ø ' },
    { key: 'laenge',      label: 'Lauflänge',   einheit: ' m' },
    { key: 'kern',        label: 'Kern',        einheit: ' mm' },
    { key: 'papierart',   label: 'Papierart',   einheit: '' }
  ];

  /* Papierklassifikation — explizit, nicht geraten.
     Schluessel sind genau die Werte, die im Katalog vorkommen. Ein Wert, der
     hier fehlt, liefert null = "unbekannt" und erfuellt damit NIE eine
     papierbezogene Geraeteanforderung. Lieber kein Treffer als ein falscher. */
  var PAPIERKLASSE = {
    'BPA-frei 48 g':   'thermo',
    'BPA-frei 55 g':   'thermo',
    'BPA-frei 75 g':   'thermo',
    'Blue4est 48 g':   'thermo',
    'Blue4est 55 g':   'thermo',
    'phenolfrei 48 g': 'thermo',
    'phenolfrei 55 g': 'thermo',
    'KLS 46':          'thermo',
    'holzfrei 60 g':   'normal',
    'unbekannt':       null
  };
  var PAPIERKLASSEN = ['thermo', 'normal'];

  /* Einsatzkontext einer Geraete-Spezifikation. Reiner Erweiterungspunkt:
     die Ergebnislogik kennt die Werte, leitet daraus aber KEINE Empfehlung ab.
     Empfehlungen entstehen erst aus gepflegten Daten, nicht aus Heuristik. */
  var GERAETETYPEN = ['payment_terminal', 'receipt_printer', 'scale', 'other'];

  function esc(wert) {
    return String(wert).replace(/[&<>"']/g, function (z) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[z];
    });
  }

  /* null/undefined/"" -> null (keine Einschraenkung). Eine echte 0 bleibt 0. */
  function zahlOderNull(wert) {
    if (wert === null || wert === undefined || wert === '') return null;
    var n = typeof wert === 'number' ? wert : parseFloat(wert);
    return isNaN(n) ? null : n;
  }

  function papierklasse(wert) {
    if (wert === null || wert === undefined) return null;
    return Object.prototype.hasOwnProperty.call(PAPIERKLASSE, wert) ? PAPIERKLASSE[wert] : null;
  }

  /* Prädikat 1 — Geraete-Spezifikation. Ohne Spezifikation passt jedes Produkt. */
  function passtZuGeraet(p, spec) {
    if (!spec) return true;

    if (spec.width_mm !== null && spec.width_mm !== undefined) {
      var breiten = Array.isArray(spec.width_mm) ? spec.width_mm : [spec.width_mm];
      var toleranz = zahlOderNull(spec.width_tolerance_mm);
      if (toleranz === null) toleranz = 0;
      var breiteOk = breiten.some(function (w) {
        var soll = zahlOderNull(w);
        return soll !== null && Math.abs(p.breite - soll) <= toleranz;
      });
      if (!breiteOk) return false;
    }

    // Kleinere Rollen passen immer — begrenzt wird nur nach oben.
    var maxDurchmesser = zahlOderNull(spec.max_roll_diameter_mm);
    if (maxDurchmesser !== null && !(p.durchmesser <= maxDurchmesser)) return false;

    // Kern nur pruefen, wenn das Geraet ihn vorgibt. Manche Geraete lassen
    // mehrere Kerndurchmesser zu (z. B. 12 und 25,4 mm) — dann ist es eine
    // Liste, genau wie bei der Breite.
    if (spec.core_diameter_mm !== null && spec.core_diameter_mm !== undefined) {
      var kerne = Array.isArray(spec.core_diameter_mm)
        ? spec.core_diameter_mm : [spec.core_diameter_mm];
      var erlaubt = kerne.map(zahlOderNull).filter(function (k) { return k !== null; });
      if (erlaubt.length && erlaubt.indexOf(p.kern) === -1) return false;
    }

    // paper_thickness_um wird BEWUSST nicht gefiltert: dafuer gibt es kein
    // Produktfeld, eine Pruefung wuerde nur falsch-negativ wirken.

    if (spec.paper_type !== null && spec.paper_type !== undefined && spec.paper_type !== '') {
      if (papierklasse(p.papierart) !== spec.paper_type) return false;
    }
    return true;
  }

  /* Prädikat 2 — Stufenauswahl. Identisch zum bisherigen Verhalten. */
  function passtZuAuswahl(p, auswahl, bisStufe) {
    return STUFEN.every(function (s, i) {
      if (bisStufe !== undefined && i >= bisStufe) return true;
      return auswahl[s.key] === undefined || p[s.key] === auswahl[s.key];
    });
  }

  function filtern(daten, auswahl, bisStufe, spec) {
    return daten.filter(function (p) {
      return passtZuGeraet(p, spec) && passtZuAuswahl(p, auswahl || {}, bisStufe);
    });
  }

  function optionen(daten, auswahl, i, spec) {
    var basis = filtern(daten, auswahl, i, spec);
    var werte = [];
    basis.forEach(function (p) {
      if (werte.indexOf(p[STUFEN[i].key]) === -1) werte.push(p[STUFEN[i].key]);
    });
    return werte.sort(function (a, b) {
      return (typeof a === 'number' && typeof b === 'number') ? a - b : String(a).localeCompare(String(b));
    });
  }

  /* Ergebnislogik in zwei Ebenen.
       compatible  — erfuellt die technischen Anforderungen des Geraets.
       recommended — zusaetzlich im Anwendungskontext sinnvoll. Bleibt vorerst
                     LEER: dafuer braucht es gepflegte Daten, keine Heuristik.
       unklar      — scheitert ausschliesslich daran, dass die Papierart des
                     Produkts unbekannt ist. Weder Treffer noch stillschweigend
                     verschluckt. */
  function bewerten(daten, spec) {
    var compatible = [], unklar = [];
    var ohnePapier = null;
    if (spec && spec.paper_type) {
      ohnePapier = {};
      Object.keys(spec).forEach(function (k) { ohnePapier[k] = spec[k]; });
      ohnePapier.paper_type = null;
    }
    daten.forEach(function (p) {
      if (passtZuGeraet(p, spec)) { compatible.push(p); return; }
      if (ohnePapier && papierklasse(p.papierart) === null && passtZuGeraet(p, ohnePapier)) {
        unklar.push(p);
      }
    });
    return {
      compatible: compatible,
      recommended: [],
      unklar: unklar,
      use_context: (spec && spec.device_type) || null
    };
  }

  function init(wurzel, daten, spec) {
    var auswahl = {};
    var basis = filtern(daten, {}, undefined, spec);
    var kopfAus = wurzel.getAttribute && wurzel.getAttribute('data-kopf') === 'aus';

    function zeichnen() {
      var treffer = filtern(basis, auswahl);
      var html = '';
      // Auf der Rollenfinder-Seite liefert das Theme bereits H1 und Einleitung.
      // Dort unterdrueckt data-kopf="aus" die Wiederholung; auf der Startseite,
      // wo der Finder ohne Rahmen steht, bleibt die Ueberschrift erhalten.
      if (!kopfAus) {
        html += '<h2>Rollenfinder</h2>' +
          '<p class="bz-finder__intro">Messen Sie Ihre alte Rolle aus und wählen Sie Schritt für Schritt. ' +
          'Es werden nur Werte angeboten, zu denen es tatsächlich Rollen gibt.</p>';
      }
      html += '<div class="bz-finder__stufen">';

      var gesperrt = false;
      STUFEN.forEach(function (s, i) {
        var opts = optionen(basis, auswahl, i);
        var aktiv = !gesperrt;
        if (auswahl[s.key] === undefined && opts.length > 1) gesperrt = true;
        if (!aktiv && opts.length === 0) return;
        html += '<div class="bz-finder__stufe"><span>' + s.label + '</span><div class="bz-finder__opts">';
        opts.forEach(function (w) {
          var gewaehlt = auswahl[s.key] === w;
          html += '<button type="button" class="bz-finder__opt" data-k="' + s.key +
                  '" data-w="' + esc(w) + '" aria-pressed="' + gewaehlt + '">' +
                  (s.prefix || '') + esc(w) + s.einheit + '</button>';
        });
        html += '</div></div>';
      });
      html += '</div>';

      html += '<p class="bz-finder__count">' + treffer.length +
              (treffer.length === 1 ? ' passende Rolle' : ' passende Rollen') +
              (Object.keys(auswahl).length ? ' &middot; <button type="button" class="bz-finder__reset">Auswahl zurücksetzen</button>' : '') +
              '</p>';

      if (treffer.length && treffer.length <= MAX_TREFFER) {
        html += '<ul class="bz-finder__treffer">';
        treffer.forEach(function (p) {
          var v = p.varianten && p.varianten[0];
          html += '<li><a href="/products/' + encodeURIComponent(p.handle) + '"><strong>' +
                  esc(p.titel) + '</strong><span>' +
                  esc(p.breite) + ' × ' + esc(p.durchmesser) + ' × ' + esc(p.kern) + ' mm &middot; ' +
                  esc(p.laenge) + ' m' +
                  (v && v.rollen_pro_karton ? ' &middot; ' + esc(v.rollen_pro_karton) + ' Rollen/Karton' : '') +
                  '</span></a></li>';
        });
        html += '</ul>';
      } else if (treffer.length > MAX_TREFFER) {
        // Ohne diesen Hinweis blieb unterhalb der Trefferzahl einfach nichts
        // stehen und die Seite sah aus, als sei sie kaputt.
        html += '<p class="bz-finder__hinweis">Bitte wählen Sie eine weitere Eigenschaft, ' +
                'dann werden die passenden Rollen hier aufgelistet.</p>';
      } else if (Object.keys(auswahl).length) {
        html += '<p class="bz-finder__hinweis">Zu dieser Kombination gibt es derzeit keine Rolle. ' +
                'Bitte setzen Sie die Auswahl zurück.</p>';
      }
      wurzel.innerHTML = html;
    }

    wurzel.addEventListener('click', function (ev) {
      var b = ev.target.closest('.bz-finder__opt');
      if (b) {
        var k = b.dataset.k, w = b.dataset.w;
        var typisiert = isNaN(parseFloat(w)) || String(parseFloat(w)) !== w ? w : parseFloat(w);
        if (auswahl[k] === typisiert) {
          delete auswahl[k];
          // nachgelagerte Stufen verwerfen, damit keine unmoegliche Kombination stehenbleibt
          var ab = STUFEN.findIndex(function (s) { return s.key === k; });
          STUFEN.slice(ab).forEach(function (s) { delete auswahl[s.key]; });
        } else {
          var idx = STUFEN.findIndex(function (s) { return s.key === k; });
          STUFEN.slice(idx + 1).forEach(function (s) { delete auswahl[s.key]; });
          auswahl[k] = typisiert;
        }
        zeichnen();
      } else if (ev.target.closest('.bz-finder__reset')) {
        auswahl = {}; zeichnen();
      }
    });
    zeichnen();
  }

  /* Sucheinstiege umschalten. Reine Verbesserung: ohne JavaScript sind beide
     Panels im HTML und der Geraetetab ist ueber seine Links nutzbar. */
  function tabsInit(wurzel) {
    var tabs = [].slice.call(wurzel.querySelectorAll('[role="tab"]'));
    if (!tabs.length) return;

    function waehle(name, fokus) {
      tabs.forEach(function (t) {
        var aktiv = t.getAttribute('data-bz-tab') === name;
        t.setAttribute('aria-selected', aktiv ? 'true' : 'false');
        t.tabIndex = aktiv ? 0 : -1;
        if (aktiv && fokus) t.focus();
      });
      [].forEach.call(wurzel.querySelectorAll('[data-bz-panel]'), function (p) {
        p.hidden = p.getAttribute('data-bz-panel') !== name;
      });
    }

    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        waehle(t.getAttribute('data-bz-tab'), false);
      });
      t.addEventListener('keydown', function (ev) {
        var schritt = ev.key === 'ArrowRight' ? 1 : ev.key === 'ArrowLeft' ? -1 : 0;
        if (ev.key === 'Home') { ev.preventDefault(); waehle(tabs[0].getAttribute('data-bz-tab'), true); return; }
        if (ev.key === 'End') { ev.preventDefault(); waehle(tabs[tabs.length - 1].getAttribute('data-bz-tab'), true); return; }
        if (!schritt) return;
        ev.preventDefault();
        var ziel = tabs[(i + schritt + tabs.length) % tabs.length];
        waehle(ziel.getAttribute('data-bz-tab'), true);
      });
    });

    // Der Leer-Zustand der Geraetesuche bietet den Rueckweg an.
    [].forEach.call(wurzel.querySelectorAll('[data-bz-tab-ziel]'), function (b) {
      b.addEventListener('click', function () {
        waehle(b.getAttribute('data-bz-tab-ziel'), true);
      });
    });

    // Tiefenlink: /pages/rollenfinder#bz-panel-geraet oeffnet gleich den
    // Geraete-Tab. OHNE JavaScript erledigt das der Browser selbst — der
    // noscript-Style zeigt dann beide Panels, das Fragment springt an die
    // Liste. MIT JavaScript ist das Panel hidden, der native Sprung liefe ins
    // Leere; deshalb wird der Tab hier aktiv geschaltet.
    //
    // Der Hash wird gegen die vorhandenen Tabs geprueft, nicht in einen
    // Selektor eingesetzt: ein Fragment wie #a"] wuerde querySelector sonst
    // zum Werfen bringen.
    //
    // Drei Faelle, alle NUR lesend auf location.hash:
    //   leerer Hash      -> der serverseitige Standardtab (Zurueck-Taste)
    //   bekannter Hash   -> der zugehoerige Tab
    //   fremder Hash     -> nicht eingreifen; #kontakt o. ae. gehoert einem
    //                       anderen Ziel auf der Seite
    // Es wird NIE in die History geschrieben: kein pushState, kein
    // replaceState, keine Zuweisung an location.hash. Ein Tabklick aendert
    // die URL deshalb weiterhin nicht (Auflage aus 3G.0).
    //
    // Fokus: beim Laden NICHT setzen. Ein erzwungener Fokussprung direkt nach
    // dem Laden ist unerwuenscht, und der Browser verwirft ihn ohnehin — der
    // Nutzer landet stattdessen ueber die normale Sprungmarkenbehandlung bei
    // der Geraeteliste. Bei einem hashchange auf der stehenden Seite gibt es
    // dagegen keinen Browsersprung; dort wandert der Fokus auf den Tab.
    var erlaubt = tabs.map(function (t) { return t.getAttribute('data-bz-tab'); });
    var standardtab = erlaubt[0];
    for (var i2 = 0; i2 < tabs.length; i2++) {
      if (tabs[i2].getAttribute('aria-selected') === 'true') {
        standardtab = tabs[i2].getAttribute('data-bz-tab');
        break;
      }
    }
    function ausHash(fokus) {
      var roh = (window.location.hash || '').replace(/^#/, '');
      if (roh === '') { waehle(standardtab, fokus === true); return; }
      var ziel = roh.replace(/^bz-panel-/, '');
      if (erlaubt.indexOf(ziel) !== -1) waehle(ziel, fokus === true);
    }
    ausHash(false);
    window.addEventListener('hashchange', function () { ausHash(true); });
  }

  /* Robuster Suchschluessel: Kleinschreibung, Umlaute aufgeloest, alles
     Nicht-Alphanumerische raus. "TM-T88VII" findet man damit auch als
     "tm t88 vii" oder "tmt88vii". */
  function suchschluessel(text) {
    return String(text).toLowerCase()
      .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss')
      .replace(/[^a-z0-9]+/g, '');
  }

  function geraetesucheInit(box) {
    var feld = box.querySelector('input[type="search"]');
    var eintraege = [].slice.call(box.querySelectorAll('[data-bz-geraet]'));
    var leer = box.querySelector('[data-bz-leer]');
    var anzahl = box.querySelector('.bz-geraetesuche__anzahl');
    if (!feld || !eintraege.length) return;
    var gesamt = anzahl ? anzahl.textContent.trim() : '';

    /* Zeigt den Zusatznamen nur dann, wenn die Eingabe ueber ihn hereinkam und
       nicht schon ueber das, was ohnehin auf der Karte steht. Sonst wuerde der
       Hinweis bei jeder Suche mitlaufen und nichts erklaeren. */
    function aliasHinweis(li, q) {
      var ziel = li.querySelector('[data-bz-alias]');
      if (!ziel) return;
      var roh = li.getAttribute('data-aliase') || '';
      var passend = '';
      if (q && roh && suchschluessel(li.getAttribute('data-basis')).indexOf(q) === -1) {
        roh.split('|').forEach(function (a) {
          if (!passend && a && suchschluessel(a).indexOf(q) !== -1) passend = a;
        });
      }
      ziel.textContent = passend ? 'Auch bekannt als: ' + passend : '';
      ziel.hidden = !passend;
    }

    function filtern() {
      var q = suchschluessel(feld.value);
      var sichtbar = 0;
      eintraege.forEach(function (li) {
        var treffer = !q || suchschluessel(li.getAttribute('data-suche')).indexOf(q) !== -1;
        li.hidden = !treffer;
        if (treffer) { sichtbar++; aliasHinweis(li, q); } else { aliasHinweis(li, ''); }
      });
      if (leer) leer.hidden = sichtbar !== 0;
      if (anzahl) {
        anzahl.textContent = q
          ? sichtbar + (sichtbar === 1 ? ' Gerät gefunden' : ' Geräte gefunden')
          : gesamt;
      }
    }

    feld.addEventListener('input', filtern);
    feld.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape') {
        if (feld.value) { feld.value = ''; filtern(); } 
        ev.stopPropagation();
        return;
      }
      if (ev.key !== 'Enter') return;
      ev.preventDefault();
      var offen = eintraege.filter(function (li) { return !li.hidden; });
      // Enter oeffnet nur, wenn die Auswahl eindeutig ist.
      if (offen.length === 1) {
        var a = offen[0].querySelector('a');
        if (a) window.location.href = a.href;
      }
    });
  }

  function autoInit() {
    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('[data-bz-tabs]').forEach(tabsInit);
      document.querySelectorAll('[data-bz-geraetesuche]').forEach(geraetesucheInit);
      document.querySelectorAll('[data-bz-rollenfinder]').forEach(function (el) {
        var quelle = el.getAttribute('data-quelle');
        if (!quelle) return;
        // data-geraet traegt spaeter die Spezifikation einer Geraeteseite.
        // Fehlt sie, laeuft der Finder wie bisher im Groessenmodus.
        var spec = null;
        var roh = el.getAttribute('data-geraet');
        if (roh) { try { spec = JSON.parse(roh); } catch (e) { spec = null; } }
        fetch(quelle).then(function (r) { return r.json(); }).then(function (d) {
          init(el, d.produkte || [], spec);
        }).catch(function () {
          el.innerHTML = '<p>Der Rollenfinder ist derzeit nicht verfügbar.</p>';
        });
      });
    });
  }

  return {
    MAX_TREFFER: MAX_TREFFER,
    STUFEN: STUFEN,
    PAPIERKLASSE: PAPIERKLASSE,
    PAPIERKLASSEN: PAPIERKLASSEN,
    GERAETETYPEN: GERAETETYPEN,
    esc: esc,
    zahlOderNull: zahlOderNull,
    papierklasse: papierklasse,
    passtZuGeraet: passtZuGeraet,
    passtZuAuswahl: passtZuAuswahl,
    filtern: filtern,
    optionen: optionen,
    bewerten: bewerten,
    suchschluessel: suchschluessel,
    tabsInit: tabsInit,
    geraetesucheInit: geraetesucheInit,
    init: init,
    autoInit: autoInit
  };
});
